import React from 'react';
import { Sparkles } from 'lucide-react';
import { useAssistant } from '../../assistant/AssistantContext';

/**
 * "Ask AI" on a record's header: opens the assistant with the cursor in the
 * composer. The page has already told it which record "this" is, so the
 * questions it suggests are about this record.
 */
export default function AskAIButton({ name, className = 'btn btn-secondary' }) {
  const { openWith } = useAssistant();
  return (
    <button type="button" className={className} onClick={() => openWith()} title={name ? `Ask the AI about ${name}` : 'Ask the AI'}>
      <Sparkles size={18} aria-hidden="true" />
      Ask AI
    </button>
  );
}
